import { FC } from "react";
import { Box, Skeleton } from "@mui/material";

const NotificationCardSkeleton: FC = () => (
  <Box
    sx={{
      padding: "16px",
    }}
  >
    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
      <Skeleton
        variant="circular"
        width={10}
        height={10}
        sx={{ marginTop: "6px" }}
      />
      <Box sx={{ flex: 1 }}>
        <Box display="flex" alignItems="center" mb={0.5} gap={0.5}>
          <Skeleton variant="text" width="30%" height={20} />
          <Skeleton variant="text" width="20%" height={16} />
        </Box>

        <Skeleton variant="text" width="100%" height={20} sx={{ mb: 0.5 }} />
        <Skeleton variant="text" width="60%" height={16} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="80px" height={18} />
      </Box>
    </Box>
  </Box>
);

export default NotificationCardSkeleton;
